module.exports = __webpack_public_path__ + "static/media/technical.526e88cc.jpg";